import React from 'react';
import cn from 'classnames';
import LazyImage from 'components/UI/LazyImage';
import Link from 'components/UI/Link';
import Icon from 'components/UI/Icon';
import Hint from 'components/UI/Hint';
import { useTrans } from 'utils/localisation';

import * as styles from './review.module.scss';

export function Component({ content, className, theme }) {
  const {
    name,
    photo,
    position,
    description,
    linkedin,
    company,
    company_link,
    country,
    country_icon,
    verified,
  } = content;
  const t = useTrans(['testimonials']);
  const isClutch = verified?.type === 'Clutch.co';

  return (
    <div className={cn(className, styles.feedbackWrapper, theme && styles[theme])} id="review">
      <header className={styles.header}>
        <div className={styles.personalDataWrapper}>
          <LazyImage src={photo} alt="Person" className={styles.photo} />
          <div className={styles.personalData}>
            {name &&
              (linkedin ? (
                <Link href={linkedin} className={styles.name}>
                  {name}
                  <Icon name="linkedin-square" className={styles.linkedinIcon} />
                </Link>
              ) : (
                <p className={styles.name}>{name}</p>
              ))}
            {position && (
              <p className={styles.position}>
                {position}{' '}
                {company &&
                  (company_link ? (
                    <Link href={company_link} className={styles.link}>
                      {company}
                    </Link>
                  ) : (
                    <>{company}</>
                  ))}
              </p>
            )}
            {country_icon && (
              <p className={styles.location}>
                <LazyImage src={country_icon} alt={country} className={styles.locationImg} />
                {country}
              </p>
            )}
          </div>
        </div>
        {isClutch && (
          <Link href={verified?.link} className={styles.clutchLink}>
            <LazyImage
              className={styles.clutchIcon}
              src="https://static.andersenlab.com/andersenlab/new-andersensite/icons/clutch-verified-color.svg"
              alt="Clutch.co"
            />
            <div className={styles.hint}>
              <Hint closeOnHover zIndex={111} content={t('Clutch.co')} withIcon />
            </div>
          </Link>
        )}
      </header>
      <div className={styles.review}>
        <p className={styles.title}>{isClutch ? t('reviewClutch') : t('review')}</p>
        <p className={styles.text}>{description}</p>
      </div>
    </div>
  );
}
